import React, { Component } from "react";

//IMPORT SVG
import mainlogo from '../../frontend/assets/img/Jainism/mainlogo.svg'
import { BASEURL } from "../../Global";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRegister: false,
        };
    }
    componentDidMount() {
        this.VisibleRegistration()
    }
    async VisibleRegistration() {
        try {
            await fetch(`${BASEURL}/themesettingswithoutauthdate`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson) {
                                this.setState({ isRegister: responseJson?.result })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }
    render() {
        return (
            <React.Fragment>
                <div className="vs-menu-wrapper">
                    <div className="vs-menu-area">
                        <button className="vs-menu-toggle"><i className="fal fa-times"></i></button>
                        <div className="mobile-logo">
                            <a href={process.env.PUBLIC_URL + "/"}><img src={mainlogo} alt="logo" /></a>
                        </div>
                        <div className="vs-mobile-menu">
                            <ul>
                                <li>
                                    <a href={process.env.PUBLIC_URL + "/"}>Home</a>

                                </li>
                                <li>
                                    <a href={process.env.PUBLIC_URL + "/about-us"}>About</a>

                                </li>
                                <li><a href={process.env.PUBLIC_URL + "/contact-us"}>Contact</a></li>
                                <li>
                                    <a href={process.env.PUBLIC_URL + "/gallary"}>Gallery</a>

                                </li>
                                {/* <li>
                                    <a href={process.env.PUBLIC_URL + "/modules"}>Modules</a>

                                </li> */}
                                {
                                    this.state.isRegister && (
                                        <li className="menu-item-has-children">
                                            <a href="#">Registraion</a>
                                            <ul className="sub-menu">
                                                <li><a href={process.env.PUBLIC_URL + "/new-registration"}>New Students</a></li>
                                                {/* <li><a href={process.env.PUBLIC_URL + "/old-registration"}>Old Students</a></li> */}
                                            </ul>
                                        </li>
                                    )
                                }
                            </ul>
                        </div>
                        <div className="vs-mobile-menu" style={{ display: 'flex', justifyContent: 'space-around' }} >
                            <div className="header-button mb-15">

                                <a href="https://myjainism.in/webportal/" target="_blank" className="vs-btn wave-btn" rel="noreferrer">Log In</a>
                            </div>
                        </div>
                    </div>
                </div>

                <header className="vs-header">
                    <div className="sticky-wrapper">
                        <div className="sticky-active">
                            <div className="header-menu-area">
                                <div className="container position-relative">
                                    <div className="row gx-20 align-items-center justify-content-between">
                                        <div className="col-1">
                                            <div className="header-logo">
                                                <a href="#">
                                                    <a href={process.env.PUBLIC_URL + "/"}><img src={mainlogo} alt="logo" /></a>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-auto">
                                            <nav className="main-menu menu-style1 d-none d-lg-inline-block">
                                                <ul>
                                                    <li>
                                                        <a href={process.env.PUBLIC_URL + "/"}>Home</a>

                                                    </li>
                                                    <li>
                                                        <a href={process.env.PUBLIC_URL + "/about-us"}>About</a>

                                                    </li>
                                                    <li><a href={process.env.PUBLIC_URL + "/contact-us"}>Contact</a></li>
                                                    <li>
                                                        <a href={process.env.PUBLIC_URL + "/gallary"}>Gallery</a>

                                                    </li>

                                                    {/* <li>
                                                        <a href={process.env.PUBLIC_URL + "/modules"}>Modules</a>
                                                    </li> */}
                                                    {
                                                        this.state.isRegister && (
                                                            <li className="menu-item-has-children">
                                                                <a href="#">Registration</a>
                                                                <ul className="sub-menu">
                                                                    <li><a href={process.env.PUBLIC_URL + "/new-registration"}>New Students</a></li>
                                                                    {/* <li><a href={process.env.PUBLIC_URL + "/old-registration"}>Old Students</a></li> */}
                                                                </ul>
                                                            </li>
                                                        )
                                                    }
                                                </ul>
                                            </nav>
                                            <button type="button" className="vs-menu-toggle d-block d-lg-none"><i className="far fa-bars"></i> Menu</button>
                                        </div>
                                        <div className="col-auto d-none d-xl-block login-btn">
                                            <div className="header-button">

                                                <a href="https://myjainism.in/webportal/" target="_blank" className="vs-btn wave-btn" rel="noreferrer">Log In</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

            </React.Fragment >
        );
    }
}

export default Header;
